export default "<app-page-with-accordion [items]=\"privacyPolicies\" title='Privacy policy'></app-page-with-accordion>\n"